<template>
	<div>
		<div class="messages-container" :style="{ height: height + 'px' }" v-scroll-bottom="messages" ref="messagesContainerRef">
			<ul>
				<li v-for="message in messageSortByTimestamp" v-bind:key="message.id">
					<div class="item-wrap" v-if="message.is_delete">
						<div class="system-content">
							<span v-if="message.is_sender">{{ $t("chatMessages.retractedMessage") }}</span>
							<span v-else>{{ message.sender_name }} {{ $t("chatMessages.retractedMessage") }}</span>
						</div>
					</div>
					<div class="item-wrap" v-if="!message.is_delete">
						<div class="content" :class="{ 'self-content': message.is_sender }">
							<div class="avatar-wrap" v-if="message.group_id">
								<el-popover placement="right" width="200" trigger="click" @show="handleUserDetail(message)" @hide="hideUserDetail">
									<div class="user-detail">
										<ChatAvatar slot="reference" class="avatar" :avatar="message.sender_avatar" borderRadius="3px" size="30" />
										<div class="user-detail-content">
											<p style="font-size: 16px; font-weight: 700">{{ userDetail.nick_name }}</p>
											<p>{{ userDetail.phone_number }}</p>
										</div>
									</div>
									<ChatAvatar slot="reference" class="avatar" :avatar="message.sender_avatar" borderRadius="3px" size="30" />
								</el-popover>
							</div>
							<div class="avatar-wrap" v-else>
								<ChatAvatar slot="reference" class="avatar" :avatar="message.sender_avatar" borderRadius="3px" size="30" />
							</div>
							<div class="body-wrap">
								<div class="name">
									<span>{{ message.sender_note ? message.sender_note : message.sender_name }}</span>
									<span class="times-tamp" v-bind:style="isToday(message.timestamp)">{{ message.timestamp | messageDateFormat }}</span>
								</div>
								<div class="message-wrap">
									<div class="message" @contextmenu.prevent.stop="handleContextmenu($event, message)">
										<!-- 文本消息 -->
										<ChatMessageText
											v-if="message.type === MESSAGE_TYPE.Text"
											:content="message.text"
											:translatedText="message.translated_text"
										/>
										<!-- 语音消息 -->
										<ChatMessageVoice
											v-else-if="message.type === MESSAGE_TYPE.Voice"
											:id="message.id"
											:attachmentUrl="message.attachment_url"
											:length="message.length"
											:isSelf="message.is_sender"
										/>
										<!-- 图片消息 -->
										<ChatMessageImage
											v-else-if="message.type === MESSAGE_TYPE.Image"
											:message="message"
											@handle-image-view="handleImageView"
										/>
										<!-- 订单信息 -->
										<ChatMessageOrder v-else-if="message.type === MESSAGE_TYPE.Order" :message="message" />
										<!-- 自动发送的订单信息 -->
										<ChatMessageMerchantOrder v-else-if="message.type === MESSAGE_TYPE.MerchantOrder" :message="message" />
										<!-- 支票上传提醒 -->
										<ChatMessageCheck v-else-if="message.type === MESSAGE_TYPE.Check" :message="message" />
										<!-- redirect消息提醒 -->
										<ChatMessageRedirect v-else-if="message.type === 5" :message="message" />
										<!--视频消息 -->
										<ChatMessageVideo v-else-if="message.type === 8" :message="message" @handle-video-viewer="handleVideoViewer" />
										<ChatMessageRedirect v-else-if="message.type === MESSAGE_TYPE.Redirect" :message="message" />
										<!-- markdown格式 -->
										<ChatMessageMarkdown
											v-else-if="message.type === MESSAGE_TYPE.Markdown"
											:message="message"
											@handle-image-view="handleImageView"
										/>
										<!-- 版本过低文本提醒 -->
										<ChatMessageNonsupport v-else />
									</div>
									<ChatMessageStatus :message="message" @on-error-click="handleStatusErrorClick($event)" />
								</div>
								<ChatMessageReadStatus v-if="message.is_sender" :message="message" :conversation="conversation" />
							</div>
						</div>
					</div>
				</li>
			</ul>
		</div>
		<vue-simple-context-menu :elementId="'message-content-menu'" :options="options" :ref="'contextMenu'" @option-clicked="handleOptionClicked" />
	</div>
</template>

<script>
import ChatMessageText from "./chat-message-text.vue";
import ChatMessageVoice from "./chat-message-voice.vue";
import ChatMessageStatus from "./chat-message-status.vue";
import ChatAvatar from "./chat-avatar.vue";
import ChatMessageReadStatus from "./chat-message-read-status.vue";
import ChatMessageOrder from "./chat-message-order.vue";
import ChatMessageMerchantOrder from "./chat-message-merchant-order.vue";
import ChatMessageImage from "./chat-message-image.vue";
import ChatMessageCheck from "./chat-message-check.vue";
import ChatMessageNonsupport from "./chat-message-nonsupport.vue";
import ChatMessageRedirect from "./chat-message-redirect.vue";
import ChatMessageVideo from "./chat-message-video.vue";
import ChatMessageMarkdown from "./chat-message-markdown.vue";
import { MESSAGE_TYPE } from "../chat";

import { getUserCustomers, postTranslatedMessage, putTranslatedShowStatus } from "@/services/api-v2/api-v2";
import { personageFormatPhone } from "@/utils/string";
import _ from "lodash";
import moment from "moment";

export default {
	name: "ChatMessages",

	components: {
		ChatMessageText,
		ChatMessageVoice,
		ChatAvatar,
		ChatMessageStatus,
		ChatMessageReadStatus,
		ChatMessageOrder,
		ChatMessageMerchantOrder,
		ChatMessageImage,
		ChatMessageCheck,
		ChatMessageRedirect,
		ChatMessageNonsupport,
		ChatMessageVideo,
		ChatMessageMarkdown,
	},

	props: {
		messages: {
			type: Array,
			required: true,
		},
		conversation: {
			type: Object,
			required: false,
			default: null,
		},
		height: {
			type: Number,
			required: false,
			default: 550,
		},
	},

	data() {
		return {
			MESSAGE_TYPE,
			options: [],
			isTodayStyle: {
				backgroundColor: "#1778bf",
				color: "#fff",
				borderRadius: "3px",
			},

			userDetail: {},
		};
	},

	methods: {
		// 发送失败重发
		handleStatusErrorClick(message) {
			this.$emit("resend-message", message);
		},

		// 消息右键
		handleContextmenu(event, message) {
			this.options = [
				{
					name: this.$t("chatMessages.copy"),
					slug: "copy",
				},
				{
					name: this.$t("chatMessages.save"),
					slug: "save",
				},
				{
					name: this.$t("chatMessages.recall"),
					slug: "recall",
				},
			];
			if (message.translated_text) {
				this.options.push({
					name: this.$t("chatMessages.concealTranslated"),
					slug: "concealTranslated",
				});
			} else {
				this.options.push({
					name: this.$t("chatMessages.translated"),
					slug: "translated",
				});
			}

			const messagesContainer = this.$refs.messagesContainerRef;
			const messagesContainerScrollTop = messagesContainer.scrollTop;
			this.$nextTick().then(() => {
				messagesContainer.scrollTop = messagesContainerScrollTop;
			});
			Object.defineProperty(event, "pageX", {
				value: event.pageX - 5,
				writable: true,
			});

			Object.defineProperty(event, "pageY", {
				value: event.pageY - 40,
				writable: true,
			});

			this.$refs.contextMenu.showMenu(event, message);
		},

		// 消息右键功能
		handleOptionClicked(event) {
			switch (event.option.slug) {
				case "copy":
					this.copyMessage(event.item);
					break;
				case "save":
					this.saveMessage(event.item);
					break;
				case "recall":
					this.recallMessage(event.item);
					break;
				case "translated":
					this.translatedMessage(event.item);
					break;
				case "concealTranslated":
					this.concealTranslatedMessage(event.item);
			}
		},

		// 消息复制
		copyMessage(message) {
			if (message.type === 0) {
				this.$copyText(message.text).then(
					() => this.$message({ message: this.$t("chatMessages.copiedToClipboard"), type: "success" }),
					() => this.$message({ message: this.$t("chatMessages.copyFailed"), type: "warning" })
				);
			} else {
				this.$message({ message: this.$t("chatMessages.supportsTextMessages"), type: "warning" });
			}
		},

		// 保存语音
		async saveMessage(message) {
			if (message.type === 1) {
				const { data } = await getUserCustomers(message.sender_id);
				const response = await fetch(message.attachment_url);
				const blob = await response.blob();
				const file = new File([blob], "new_voice_name.aac", { type: blob.type });
				const url = URL.createObjectURL(file);
				const link = document.createElement("a");
				if (data.id.length > 230) {
					const dataId = data.id.slice(0, 230);
					link.download = `${message.timestamp}-${dataId}.aac`;
				} else {
					link.download = `${message.timestamp}-${data.id}.aac`;
				}
				link.href = url;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} else {
				this.$message({ message: this.$t("chatMessages.supportsTextVoice"), type: "warning" });
			}
		},

		// 消息撤回
		recallMessage(message) {
			this.$emit("recall-message", message);
		},

		// 翻译消息
		async translatedMessage(message) {
			if (message.type !== 0) {
				this.$message({ message: this.$t("chatMessages.supportsTexttranslated"), type: "warning" });
				return;
			}
			try {
				const messagesContainer = this.$refs.messagesContainerRef;
				const messagesContainerScrollTop = messagesContainer.scrollTop;
				const { data } = await postTranslatedMessage(message.id, message.text, "zh-TW");
				message.translated_text = data.translated_text;
				this.$nextTick().then(() => {
					messagesContainer.scrollTop = messagesContainerScrollTop;
				});
			} catch (error) {
				this.$message({ message: error, type: "error" });
			}
		},

		// 隐藏翻译消息
		async concealTranslatedMessage(message) {
			if (!message.translated_text) {
				return;
			}
			try {
				const messagesContainer = this.$refs.messagesContainerRef;
				const messagesContainerScrollTop = messagesContainer.scrollTop;
				await putTranslatedShowStatus(message.id, 0);
				message.translated_text = null;
				this.$nextTick().then(() => {
					messagesContainer.scrollTop = messagesContainerScrollTop;
				});
			} catch (error) {
				this.$message({ message: error, type: "error" });
			}
		},

		// 图片查看点击事件
		handleImageView(message) {
			this.$emit("handle-image-view", message);
		},

		handleVideoViewer(message) {
			this.$emit("handle-video-viewer", message);
		},

		isToday(date) {
			const utcOffset = (new Date().getTimezoneOffset() / 60) * -1;

			const inputDate = moment(date + "+00:00")
				.utc()
				.utcOffset(utcOffset);

			const currentDate = moment().utc().utcOffset(utcOffset);

			if (inputDate.format("YYYY-MM-DD") == currentDate.format("YYYY-MM-DD")) {
				return this.isTodayStyle;
			} else {
				return "";
			}
		},

		// 获取消息关联客户详情信息
		async handleUserDetail(message) {
			try {
				if (!message.group_id) {
					return;
				}

				const messagesContainer = this.$refs.messagesContainerRef;
				const messagesContainerScrollTop = messagesContainer.scrollTop;
				const { data } = await getUserCustomers(message.sender_id);
				if (data.phone_number) {
					data.phone_number = personageFormatPhone(data.phone_number);
				}
				this.userDetail = data;

				this.$nextTick().then(() => {
					messagesContainer.scrollTop = messagesContainerScrollTop;
				});
			} catch (error) {
				this.$message({ message: error, type: "error" });
			}
		},

		//清空联系人信息
		hideUserDetail() {
			const messagesContainer = this.$refs.messagesContainerRef;
			const messagesContainerScrollTop = messagesContainer.scrollTop;
			this.userDetail = {};

			this.$nextTick().then(() => {
				messagesContainer.scrollTop = messagesContainerScrollTop;
			});
		},
	},

	directives: {
		// 发送消息后滚动到底部
		"scroll-bottom": {
			// 钩子函数，所有父子组件更新完后执行
			componentUpdated: function (el, binding, vnode) {
				el.scrollTop = el.scrollHeight - el.clientHeight;
			},
		},
	},

	computed: {
		messageSortByTimestamp() {
			return _.sortBy(this.messages, ["timestamp"]);
		},
	},
};
</script>

<style lang="less">
// 右键菜单样式
.vue-simple-context-menu {
	font-family: "PingFang SC,Hiragino Sans GB,Helvetica Neue,Microsoft Yahei" !important;
	font-size: 12px !important;
	color: #606266 !important;
	background-color: #ffffff !important;
}

.vue-simple-context-menu__item:hover {
	background-color: #ecf5ff !important;
	color: #1989fa !important;
}
</style>

<style lang="less" scoped>
.messages-container {
	overflow-y: scroll;
	// height: 550px !important;
	background-color: #c3c3c30d;
	border: 1px solid #d6d6d670;

	ul {
		list-style: none;
		padding-left: 0px;
	}

	.item-wrap {
		display: flex;
		flex: 1;
		flex-direction: column;

		.datetime {
			text-align: center;
			font-size: 12px;
			color: #dcdcdc;
		}

		.content {
			display: flex;
			flex: 1;
			flex-direction: row;
			gap: 10px;
			margin-left: 15px;
			margin-right: 15px;
			margin-top: 15px;
			.avatar-wrap {
				display: flex;
				align-items: flex-start;

				.avatar {
					display: block;
				}
			}

			.body-wrap {
				display: flex;
				// text-align: left;
				flex: 1;
				flex-direction: column;

				.name {
					font-size: 12px;
					color: #c0c0c0;
					margin-bottom: 8px;

					.times-tamp {
						margin-left: 5px;
					}
				}

				.message-wrap {
					flex: 1;
					display: flex;
					align-items: center;
					gap: 5px;
					min-width: 250px;

					.message {
						// flex: 1;
						display: inline-block;
						// position: relative;
						padding: 10px;
						max-width: ~"calc(80%)";
						// min-height: 30px;
						// line-height: 2.5;
						font-size: 12px;
						// word-break: break-all;
						background-color: #dfdfdf;
						border-radius: 4px;
						// white-space: pre-line;
					}
				}
			}
		}

		.self-content {
			flex-direction: row-reverse;

			.body-wrap {
				// text-align: right;
				align-items: flex-end;

				.message-wrap {
					flex-direction: row-reverse;

					.message {
						background-color: #b2e281;
					}
				}
			}
		}
	}

	.system-content {
		text-align: center;
		margin-bottom: 10px;
		margin-top: 10px;

		> span {
			display: inline-block;
			padding: 0 18px;
			font-size: 12px;
			color: #fff;
			border-radius: 2px;
			background-color: #dcdcdc;
		}
	}
}
.image {
	display: inherit;
	width: 150px;
	height: 150px;
	max-width: 100%;
	max-height: 100%;
	vertical-align: middle;
	cursor: pointer;
	background-color: #d3d3d3;
}
.user-detail {
	display: flex;
	.user-detail-content {
		margin-left: 10px;
		p {
			margin-top: 0;
		}
	}
}
</style>
